import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';
import LocalizedMessage from 'react-l10n';
import useFormState from '../../FormStateHelper';
import { validateForm } from '../../../selectors/defaultSelectors';
import ReferralCouponFormFields from '../../common/ReferralCouponFormFields';

function ReferralCouponForm(props) {
    const {
        handleFormSubmission,
        closeForm,
        showMoreFields,
        businessName,
    } = props;
    const {
        formData,
        bindUpdateFormData,
        isSubmitting,
        submitForm,
        updateFormData,
    } = useFormState({
        handleFormSubmission: handleFormSubmission,
        initialFormState: {},
    });
    const [isValidated, setIsValidated] = useState(false);
    let fieldRefs = {};

    const finalFormData = {
        ...formData,
    };

    const onFormSubmit = (e) => {
        e.preventDefault();

        submitForm(finalFormData, {
            success: () => {
                closeForm();
            },
        });
    };

    const onFieldUpdate = (e) => {
        bindUpdateFormData(e);
    };

    // Effects
    // --------------------
    // - Validate form
    useEffect(() => {
        setIsValidated(!validateForm(fieldRefs));
    }, [finalFormData]);

    // - Initialization
    useEffect(() => {
        updateFormData('BusinessName', businessName);
        updateFormData('showMoreFields', showMoreFields);
    }, []);

    return (
        <>
            <form className='form form-box' onSubmit={onFormSubmit}>
                <div className='vspace vspace--small'>
                    <span className='heading heading--lv5'>
                        <LocalizedMessage
                            id={'ACCOUNT_REFERRAL_COUPON.ADD_NEW'}
                        />
                    </span>
                </div>
                <div className='vspace vspace--small'>
                    <ReferralCouponFormFields
                        fieldRefs={fieldRefs}
                        formData={finalFormData}
                        onFieldUpdate={onFieldUpdate}
                        showMoreFields={showMoreFields}
                    />
                </div>

                <div className='row row--vcenter'>
                    <div className='col-xs-6'>
                        <button
                            type='submit'
                            className={`form__submit button ${
                                !isValidated ? 'button--disabled' : ''
                            }`}
                            disabled={!isValidated}
                        >
                            <span
                                style={{
                                    opacity: isSubmitting === true ? 0 : 1,
                                }}
                            >
                                <LocalizedMessage id={'SAVE'} />
                            </span>
                            {isSubmitting === true && (
                                <ReactLoading
                                    className='button__spinner'
                                    type='spin'
                                    color='white'
                                    height={20}
                                    width={20}
                                />
                            )}
                        </button>
                    </div>
                    <div className='col-xs-6 tx-right'>
                        <button
                            type='button'
                            className='button button--transparent'
                            onClick={() => closeForm()}
                        >
                            <span>
                                <LocalizedMessage id={'CANCEL'} />
                            </span>
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
}

export default ReferralCouponForm;
